import { render, staticRenderFns } from "./aRoomDetailHisOwner.vue?vue&type=template&id=50e9eec1&scoped=true"
import script from "./aRoomDetailHisOwner.vue?vue&type=script&lang=js"
export * from "./aRoomDetailHisOwner.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailHisOwner.vue?vue&type=style&index=0&id=50e9eec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e9eec1",
  null
  
)

export default component.exports